import { padZerosLeft } from 'commons/helpers/StringHelper';
import { PTR_LENGTH } from 'constants/products';
import PropTypes from 'prop-types';
import React from 'react';

export default function PtrCell(props) {

  return (
    <td>
      <a target="_blank"
        href={`/#/Inventaire/Produit=${props.dataItem.prod_num}`}
        className="blueLink"
        rel='noreferrer'
      >{padZerosLeft(props.dataItem.prod_num, PTR_LENGTH)}</a>
    </td>
  );
}

PtrCell.propTypes = {
  dataItem: PropTypes.any,
  field: PropTypes.any,
};
